import React, { useEffect } from 'react';

function HighlightDrawer({ isOpen, onClose, highlight }) {
    // Prevent background scrolling when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen || !highlight) return null;

    return (
        <div className="fixed inset-0 z-[100] flex justify-start">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Drawer Panel */}
            <div className="relative z-[101] h-full w-full max-w-md bg-white dark:bg-[#1a2333] shadow-2xl overflow-y-auto animate-slide-in-left p-8 border-r border-slate-200 dark:border-slate-800">
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-500"
                >
                    <span className="material-symbols-outlined">close</span>
                </button>

                <div className="flex items-center gap-4 mb-6">
                    <div className="text-primary dark:text-sky-300 bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center">
                        <span className="material-symbols-outlined text-4xl">{highlight.icon}</span>
                    </div>
                </div>

                <h2 className="text-3xl font-black mb-6 text-slate-900 dark:text-white leading-tight">
                    {highlight.title}
                </h2>

                <div className="space-y-8">
                    <div>
                        <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-3 tracking-wider">Overview</h3>
                        <p className="text-slate-600 dark:text-[#92a4c9] leading-relaxed text-lg">
                            {highlight.description}
                        </p>
                    </div>

                    {highlight.detailedDescription && (
                        <div>
                            <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-3 tracking-wider">Detailed Insight</h3>
                            <p className="text-slate-600 dark:text-[#92a4c9] leading-relaxed">
                                {highlight.detailedDescription}
                            </p>
                        </div>
                    )}

                    {highlight.bullets && highlight.bullets.length > 0 && (
                        <div>
                            <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-4 tracking-wider">Key Capabilities</h3>
                            <div className="grid grid-cols-1 gap-3">
                                {highlight.bullets.map((bullet, index) => (
                                    <div key={index} className="p-4 rounded-lg bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                                        <div className="flex items-start gap-3">
                                            <span className="material-symbols-outlined text-primary dark:text-sky-300 text-sm mt-1">check_circle</span>
                                            <span className="text-slate-700 dark:text-slate-300 text-sm font-medium">{bullet}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HighlightDrawer;
